import React from 'react';

const FILTER_OPTIONS = [
  { value: 'qa', label: 'Q&A' },
  { value: 'summary', label: 'SUMMARY' },
  { value: 'both', label: 'BOTH' },
];

function AudioTypeSelector({ activeFilter, onChange }) {
  return (
    <div className="audio-type-selector">
      {FILTER_OPTIONS.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          className={`audio-type-selector__button audio-type-selector__button--${value}${
            activeFilter === value ? ' audio-type-selector__button--active' : ''
          }`}
          onClick={() => onChange(value)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default AudioTypeSelector;
